import isNumber from './is-number';

const isDecimal = function(num: any): boolean {
  return isNumber(num) && num % 1 !== 0;
};

export default isDecimal;
